import { createSelector } from 'reselect'
import { OdoStore } from 'store'

const settingsSlice = (state: OdoStore) => state.settings

export const theme = createSelector([settingsSlice], state => state.theme)
